export class Get {
	static readonly type = '[FeatureFlags] get featureFlag';
}
